import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DocumentService } from '../../../documents/documents.service';
import { SharedModule } from '../../shared.module';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-material-image-viewer',
  templateUrl: './material-image-viewer.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SharedModule, MatButtonModule]
})
export class MaterialImageViewerComponent {
  @Output() rmFileId: EventEmitter<string> = new EventEmitter<string>();

  src: any;
  _alt?: string;
  _cssClasses?: string;
  constructor(private _documentsService: DocumentService) { }

  @Input() set documentId(value: string) {
    this.src = '/assets/icons/main-logo/person.jpg';
    if (value) {
      this._documentsService.download(value).subscribe(b => {
        this.src = URL.createObjectURL(b.body);
      });
    }
  }

  @Input() set class(value: string) {
    this._cssClasses = value;
  }

  @Input() set alt(value: string) {
    this._alt = value;
  }
}
